<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
<ziro-collapsible-section-card
  [hidden]="isLoading"
  [isSwitchHidden]="true"
  [title]="'tkey;admin.webex_authentication.application_info.header'"
  [isCollapsible]="false"
>
  <ziro-text fieldId="clientId" [disabled]="clientIdExists"></ziro-text>
  <ziro-text #clientSecret fieldId="clientSecret" [disabled]="clientIdExists"></ziro-text>
  <ziro-text [borderRadOnlyLeft]="true" fieldId="redirectUri">
    <ziro-button
      [dataAutomation]="'copy-button'"
      [buttonStyle]="buttonStyles.OUTLINE_DEFAULT"
      [borderClass]="'input-text-end'"
      [label]="'tkey;admin.webex_authentication.copy_button'"
      [cssClass]="'btn-input-copy'"
      [cdkCopyToClipboard]="callingSettings()?.redirectUri"
      [ngbTooltip]="'tkey;admin.webex_authentication.copy_button_clicked' | translate"
      [icon]="ziroIcons.COPY"
      #t="ngbTooltip"
      [triggers]="'click'"
      (clicked)="onCopyUriClick(t)"
    ></ziro-button>
  </ziro-text>
</ziro-collapsible-section-card>

<ziro-collapsible-section-card
  [isSwitchHidden]="true"
  [title]="'tkey;admin.webex_authentication.service_account_info.header'"
  [isCollapsible]="false"
>
  @if (!clientIdExists) {
    <div>
      <p>{{ 'tkey;admin.webex_authentication.no_client_or_secret' | translate }}</p>
    </div>
  }
  @if (clientIdExists) {
    <div>
      @switch (callingStatus?.status) {
        @case (WebexCallingStatusEnum.OK) {
          <div>
            <p
              data-automation="service-acct-text"
              class="mb-0"
              [innerHTML]="
                'tkey;admin.webex_authentication.connected_text'
                  | escapeHtml
                    : {
                        currentUserId: callingStatus?.currentUserId,
                        accessTokenExpirationDate: formattedExpirationDate,
                      }
              "
            ></p>
            @if (!isRefreshing) {
              <a data-automation="refresh-tokens" class="strong refresh" (click)="onRefreshTokensClick()">
                <i [ngClass]="ziroIcons.REFRESH"></i>
                {{ 'tkey;admin.webex_authentication.refresh_tokens_link' | translate }}
              </a>
            }
            @if (isRefreshing) {
              <a class="strong text-warning disabled refresh-disabled">
                <i [ngClass]="ziroIcons.SAVING"></i>
                {{ 'tkey;admin.webex_authentication.refresh_tokens_link.refreshing' | translate }}
              </a>
            }
          </div>
        }
        @case (WebexCallingStatusEnum.ERROR) {
          <div>
            <p data-automation="service-acct-text">{{ 'tkey;admin.webex_authentication.error' | translate }}</p>
            <div class="d-flex justify-content-center">
              <ziro-button
                [dataAutomation]="'webex-login-button'"
                [label]="'tkey;admin.webex_authentication.login_button_text'"
                [buttonStyle]="buttonStyles.OUTLINE_PRIMARY"
                (clicked)="redirectToWebex()"
              ></ziro-button>
            </div>
          </div>
        }
        @default {
          <div>
            <p data-automation="service-acct-text">
              {{ 'tkey;admin.webex_authentication.not_configured' | translate }}
            </p>
            <div class="d-flex justify-content-center">
              <ziro-button
                [dataAutomation]="'webex-login-button'"
                [label]="'tkey;admin.webex_authentication.login_button_text'"
                [buttonStyle]="buttonStyles.OUTLINE_PRIMARY"
                (clicked)="redirectToWebex()"
              ></ziro-button>
            </div>
          </div>
        }
      }
    </div>
  }
</ziro-collapsible-section-card>
